/*  Modified version of JedWatson's react-input-autosize
 *  Adapted from https://github.com/JedWatson/react-input-autosize
 */

/* tslint:disable:restrict-plus-operands */

import * as PropTypes from 'prop-types';
import React from 'react';

const sizerStyle: any = {
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
  height: 0,
  overflow: 'scroll',
  whiteSpace: 'pre'
};

export class AutoSizeInput extends React.Component<any, any> {
  static propTypes = {
    className: PropTypes.string, // className for the outer element
    defaultValue: PropTypes.string, // default field value
    inputClassName: PropTypes.string, // className for the input element
    minWidth: PropTypes.oneOfType([
      // minimum width for input element
      PropTypes.number,
      PropTypes.string
    ]),
    onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
    placeholder: PropTypes.string, // placeholder text
    placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
    value: PropTypes.string, // field value
    textarea: PropTypes.bool, // textarea support
    offset: PropTypes.number // offset pixels
  };

  static defaultProps = {
    minWidth: 1,
    offset: 10
  };

  input: HTMLElement;
  sizer: HTMLElement;
  placeholderSizer: HTMLElement;

  constructor(props) {
    super(props);

    this.state = {
      inputWidth: props.minWidth
    };
  }

  componentDidMount() {
    this.copyInputStyles();
    this.updateInputWidth();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onAutosize && prevState.inputWidth !== this.state.inputWidth) {
      this.props.onAutosize(this.state.inputWidth);
    }
    this.updateInputWidth();
  }

  copyInputStyles = () => {
    const { sizer, placeholderSizer } = this;
    const { placeholder } = this.props;

    if (!window.getComputedStyle) {
      return;
    }
    const inputStyle = window.getComputedStyle(this.input);
    if (!inputStyle) {
      return;
    }
    const widthNode = sizer;
    widthNode.style.fontSize = inputStyle.fontSize;
    widthNode.style.fontFamily = inputStyle.fontFamily;
    widthNode.style.fontWeight = inputStyle.fontWeight;
    widthNode.style.fontStyle = inputStyle.fontStyle;
    widthNode.style.letterSpacing = inputStyle.letterSpacing;
    if (placeholder) {
      const placeholderNode = placeholderSizer;
      placeholderNode.style.fontSize = inputStyle.fontSize;
      placeholderNode.style.fontFamily = inputStyle.fontFamily;
      placeholderNode.style.fontWeight = inputStyle.fontWeight;
      placeholderNode.style.fontStyle = inputStyle.fontStyle;
      placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
    }
  };

  updateInputWidth = () => {
    const { value, placeholder, placeholderIsMinWidth, offset, minWidth } = this.props;
    const { inputWidth } = this.state;
    const { sizer, placeholderSizer } = this;

    if (sizer.scrollWidth === undefined) {
      return;
    }
    let newInputWidth;
    if (placeholder && (!value || (value && placeholderIsMinWidth))) {
      newInputWidth = Math.max(sizer.scrollWidth, placeholderSizer.scrollWidth) + offset;
    } else {
      newInputWidth = sizer.scrollWidth + offset;
    }
    if (newInputWidth < minWidth) {
      newInputWidth = minWidth;
    }
    if (newInputWidth !== inputWidth) {
      this.setState({
        inputWidth: newInputWidth
      });
    }
  };

  render() {
    const sizerValue = [this.props.defaultValue, this.props.value, ''].reduce((previousValue, currentValue) => {
      if (previousValue !== null && previousValue !== undefined) {
        return previousValue;
      }
      return currentValue;
    });

    const wrapperStyle = {};
    const inputStyle: any = {};

    inputStyle.width = `${this.state.inputWidth + this.props.offset}px`;
    inputStyle.boxSizing = 'content-box';
    const inputProps = { ...this.props } as any;
    inputProps.className = this.props.inputClassName;
    inputProps.style = inputStyle;
    // ensure props meant for `AutosizeInput` don't end up on the `input`
    delete inputProps.inputClassName;
    delete inputProps.inputStyle;
    delete inputProps.minWidth;
    delete inputProps.placeholderIsMinWidth;
    delete inputProps.textarea;
    return (
      <div className={this.props.className} style={wrapperStyle}>
        {this.props.textarea ? (
          <textarea
            {...inputProps}
            ref={input => {
              this.input = input;
            }}
          />
        ) : (
          <input
            {...inputProps}
            ref={input => {
              this.input = input;
            }}
          />
        )}
        <div
          ref={sizer => {
            this.sizer = sizer;
          }}
          style={sizerStyle}
        >
          {sizerValue}
        </div>
        {this.props.placeholder ? (
          <div
            ref={placeholderSizer => {
              this.placeholderSizer = placeholderSizer;
            }}
            style={sizerStyle}
          >
            {this.props.placeholder}
          </div>
        ) : null}
      </div>
    );
  }
}
